export default "__VITE_ASSET__DHeGJK6d__"